<template>
  <div class="comment__audit-compare-content comment__item-severity-content">
    <span
      v-if="beforeSeverity"
      class="severity-level is-opacity"
    >
      <SeverityLevelIcon :level="beforeSeverity" />
      {{ capitalize(beforeSeverity) }}
    </span>
    <span
      v-else
      class="is-opacity"
      >{{ $t("none") }}</span
    >

    <icon
      data="@icon/arrow-to.svg"
      class="add-bg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome05to04)"
    />
    <span
      v-if="afterSeverity"
      class="severity-level"
    >
      {{ capitalize(afterSeverity) }}
      <SeverityLevelIcon :level="afterSeverity" />
    </span>
    <span
      v-else
      class="is-opacity"
      >{{ $t("none") }}</span
    >
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import SeverityLevelIcon from "@/components/SeverityLevel/SeverityLevelIcon.vue"

import { Comment } from "@/models"
import { capitalizeOnlyFirstLetter } from "@/utils/helpers"

const props = defineProps<{
  comment: Comment
}>()

const beforeSeverity = computed(() => props.comment.before?.severityLevel ?? null)
const afterSeverity = computed(() => props.comment.after?.severityLevel ?? null)

function capitalize(value: string) {
  return capitalizeOnlyFirstLetter(value)
}
</script>
